import React from 'react'
import './search.scss'

const Search = ({ searchInput, setSearchInput, letterSearch, setLetterSearch }) => {
    const letters = [{ letter: "A" }, { letter: "B" }, { letter: "C" }, { letter: "D" }, { letter: "E" },
    { letter: "F" }, { letter: "G" }, { letter: "H" }, { letter: "I" }, { letter: "J" }, { letter: "K" }, { letter: "L" },
    { letter: "M" }, { letter: "N" }, { letter: "O" }, { letter: "P" }, { letter: "Q" }, { letter: "R" },
    { letter: "S" }, { letter: "T" }, { letter: "U" }, { letter: "V" }, { letter: "W" }, { letter: "X" }, { letter: "Y" }, { letter: "Z" }]

    const handleScrollSearch = () => {
        window.scrollTo( 0, 400 );
    }

    return (
        <div className="f-winner-search">
            <p className="f-winner-search-title">¡Encuentra tu nombre!</p>
            <div className="f-input-search-container">
                <input value={searchInput} onChange={e => {
                    setSearchInput(e.target.value)
                    setLetterSearch("")
                }} className="f-winner-search-input" placeholder="Escribe aquí" type="text" />
                <span className="icon-search f-icon f-icon-search" onClick={() => handleScrollSearch()}/>
            </div>
            <div className="f-winner-search-letters">
                {letters.map((letter, index) =>
                    <span key={index} className={letterSearch === letter.letter ? "f-winner-search-letters-active" : ""}
                        onClick={() => {
                            if(letterSearch === letter.letter){
                                setLetterSearch("")
                            }else{
                                setLetterSearch(letter.letter)
                            }
                            
                            setSearchInput("")
                        }}>{letter.letter}</span>

                )
                }
            </div>
        </div>
    )
}

export default Search
